import Vue from 'vue'
import Vuex from 'vuex'
import FileInfo from './modules/filelist.js'
import MenuList from './modules/currentSeletctFileMenu.js'
import Actionlist from './modules/currentFolderMenu.js'
import Sortlist from './modules/navigator.js'
import Senselist from './modules/sortlist.js'
import Search from './modules/search.js'
import Logout from './modules/logout.js'
import Delivery from './modules/delivery.js'
import MoveCopy from './modules/movecopy.js'
import Message from './modules/message.js'
import Comments from './modules/comments.js'
import History from './modules/history.js'
import DeliveryTransfor from './modules/deliveryTransfor.js'
import * as Util from 'util'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    allInfo: [],
    userInfo: null,
    token: null,
    title: '',
    startUpload: false,
    isSearch: false,
    searchKeyword: '',
    startPreview: false,
    onlyWIFI: false,
    currentNetworkType: 2, // 0无网络 1WIFI 2移动网络
    configJson: {},
    toast: {
      isShow: false,
      message: '',
      iconClass: '',
      autoClose: true
    },
    progress: {
      isShow: false,
      message: ''
    }
  },
  getters: {
    getAllInfo: state => state.allInfo,
    getConfigJson: state => state.configJson,
    getCurrentNetworkType: state => state.currentNetworkType,
    getCurrentUserInfo: state => state.userInfo
  },
  mutations: {
    setAllInfo (state, obj) {
      state.allInfo = obj
    },
    setStartUpload (state, obj) {
      state.startUpload = obj
    },
    setStartPreview (state, obj) {
      state.startPreview = obj
    },
    login: (state, data) => {
      state.userInfo = data
    },
    logout: (state) => {
      localStorage.removeItem('userInfo')
      state.userInfo = null
      Util.delCookie('X-LENOVO-SESS-ID')
    },
    setToast (state, obj) {
      state.toast = obj
    },
    setProgress (state, obj) {
      state.progress = obj
    },
    setIsSearch (state, obj) {
      state.isSearch = obj
    },
    setNetworkType (state, obj) {
      state.currentNetworkType = obj
    },
    setOnlyWIFI (state, obj) {
      state.onlyWIFI = obj
    }
  },
  actions: {
    set_AllInfo ({commit}, obj) {
      commit('setAllInfo', obj)
    }
  },

  modules: {
    fileInfo: FileInfo,
    actionList: Actionlist,
    sortList: Sortlist,
    senseList: Senselist,
    search: Search,
    menuList: MenuList,
    logout: Logout,
    delivery: Delivery,
    movecopy: MoveCopy,
    comments: Comments,
    history: History,
    message: Message,
    deliveryTransfor: DeliveryTransfor
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js